module.exports = __webpack_public_path__ + "img/404.163d29af.svg";